var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "modal",
      staticClass: "modal fade",
      staticStyle: { overflow: "hidden", "z-index": "2000" },
      attrs: { "data-backdrop": "static" }
    },
    [
      _c(
        "div",
        { staticClass: "modal-dialog modal-xs", attrs: { role: "document" } },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("h5", { staticClass: "modal-title" }, [
                _c("b", [_vm._v(_vm._s(_vm.$t("kanbanCreateBoard")))])
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: { type: "button" },
                  on: { click: _vm.dismiss }
                },
                [_vm._v("×")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c("div", { staticClass: "form-group" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("kanbanName")) +
                    "\n                    "
                ),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.boardName,
                      expression: "boardName"
                    }
                  ],
                  staticClass: "form-control",
                  domProps: { value: _vm.boardName },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.boardName = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group mb-0" },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("kanbanTemplate")) +
                      "\n                    "
                  ),
                  _c("v-select", {
                    attrs: {
                      options: _vm.templates,
                      label: "name",
                      reduce: e => e.id,
                      clearable: false
                    },
                    model: {
                      value: _vm.selectedTemplate,
                      callback: function($$v) {
                        _vm.selectedTemplate = $$v
                      },
                      expression: "selectedTemplate"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  on: { click: _vm.dismiss }
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("btnCancel")) +
                      "\n                "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  attrs: {
                    disabled:
                      !_vm.boardName ||
                      !_vm.boardName.trim() ||
                      _vm.loadingSymbol
                  },
                  on: { click: _vm.create }
                },
                [
                  _vm.loadingSymbol
                    ? [
                        _c("span", {
                          staticClass: "spinner-border spinner-border-sm",
                          attrs: { role: "status", "aria-hidden": "true" }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "sr-only" }, [
                          _vm._v("Loading...")
                        ])
                      ]
                    : _vm._e(),
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("btnCreate")) +
                      "\n                "
                  )
                ],
                2
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }